import { Stack, type SxProps } from '@mui/material';
import type { ReactElement, ReactNode } from 'react';

import Label from '../Label';
import Text from '../Text';

interface Props {
  children: ReactElement;
  label?: ReactNode | string;
  tooltipText?: ReactNode | string;
  helperText?: ReactNode | string;
  sx?: SxProps;
  direction?: 'row' | 'column';
  justifyContent?: 'flex-start' | 'center' | 'flex-end' | 'space-between';
  alignItems?: 'stretch' | 'flex-start' | 'center' | 'flex-end';
}

export default function WithLabel({
  children,
  label,
  tooltipText,
  helperText,
  sx,
  direction = 'column',
  justifyContent = 'flex-start',
  alignItems = 'stretch',
}: Props) {
  if (label) {
    return (
      <Stack
        direction={direction}
        sx={[
          {
            gap: 0.5,
            justifyContent: justifyContent,
            alignItems: alignItems,
          },
          ...(Array.isArray(sx) ? sx : [sx]),
        ]}
      >
        <Label tooltipText={tooltipText}>{label}</Label>
        {helperText && (
          <Text
            size="small"
            color="grey"
          >
            {helperText}
          </Text>
        )}
        {children}
      </Stack>
    );
  }

  return children;
}
